import { Sprite, Loader, Point } from 'pixi.js';
import gsap from 'gsap';
import eventHub from '@/scripts/eventHub';
import audio from '@/scripts/audio';
import Actor from './Actor';
import PowerDownLevel from './PowerDownLevel';
import vars from '../vars';

class PowerDownArea extends Actor {
  constructor(parent) {
    super(parent);

    this.ref = new Sprite();

    this.currentLevel = 0;
    this.levelOne = new PowerDownLevel(this.ref, 1);
    this.levelTwo = new PowerDownLevel(this.ref, 2);
    this.levelThree = new PowerDownLevel(this.ref, 3);
    this.updateLevel(0);

    const backgroundSheet = Loader.shared.resources['images/BACKGROUND'].spritesheet.textures;
    this.baseBlack = new Sprite(backgroundSheet['basic-black.png']);
    this.ref.addChild(this.baseBlack);

    this.basicBranchesLeft = new Sprite(backgroundSheet['basic-branches-left.png']);
    this.basicBranchesRight = new Sprite(backgroundSheet['basic-branches-right.png']);
    this.ref.addChild(this.basicBranchesLeft);
    this.ref.addChild(this.basicBranchesRight);

    this.resize();

    this.hitHandler = () => { this.updateLevel(+1); };
    this.resetHitHandler = () => { this.updateLevel(0); };
    eventHub.$on('hit', this.hitHandler);
    eventHub.$on('reset-hit', this.resetHitHandler);

    this.parent.ref.addChild(this.ref);
  }

  resize() {
    this.baseBlack.position.y = -vars.layout.FRAME_DIFFERENCE_TOP;

    this.basicBranchesLeft.anchor = new Point(0, 0);
    this.basicBranchesRight.anchor = new Point(1, 0);
    this.basicBranchesLeft.position.y = -vars.layout.FRAME_DIFFERENCE_TOP;
    this.basicBranchesRight.position.y = -vars.layout.FRAME_DIFFERENCE_TOP;
    this.basicBranchesLeft.position.x = -50;
    this.basicBranchesRight.position.x = vars.layout.STAGE_WIDTH + 50;

    gsap.to(this.basicBranchesLeft.position, {
      y: `-=${8}`,
      x: `-=${10}`,
      repeat: -1,
      yoyo: true,
      ease: 'power2.inOut',
      duration: 4,
    });
    gsap.to(this.basicBranchesRight.position, {
      y: `+=${8}`,
      x: `+=${10}`,
      delay: 0.2,
      repeat: -1,
      yoyo: true,
      ease: 'power2.inOut',
      duration: 4,
    });
  }

  updateLevel(modifier) {
    this.currentLevel += modifier;
    if (modifier === 0) { this.currentLevel = 0; }

    if (this.currentLevel === 0) {
      this.levelOne.hidden = true;
      this.levelTwo.hidden = true;
      this.levelThree.hidden = true;
    }
    if (this.currentLevel === 1) {
      this.levelOne.hidden = false;
      this.levelTwo.hidden = true;
      this.levelThree.hidden = true;
      audio.play('branches');
    }
    if (this.currentLevel === 2) {
      this.levelOne.hidden = false;
      this.levelTwo.hidden = false;
      this.levelThree.hidden = true;
      audio.play('branches');
    }
    if (this.currentLevel === 3) {
      this.levelOne.hidden = false;
      this.levelTwo.hidden = false;
      this.levelThree.hidden = false;
      audio.play('branches');
    }
  }

  destroy() {
    eventHub.$off('hit', this.hitHandler);
    eventHub.$off('reset-hit', this.resetHitHandler);
    this.ref.destroy({ children: true });
  }
}

export default PowerDownArea;
